var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartBuilderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 2H3.33325C2.78097 2 2.33325 2.44772 2.33325 3V15C2.33325 15.5523 2.78097 16 3.33325 16H7.33325C7.88554 16 8.33325 15.5523 8.33325 15V3C8.33325 2.44772 7.88554 2 7.33325 2Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 2H12.3333C11.781 2 11.3333 2.44772 11.3333 3V4C11.3333 4.55228 11.781 5 12.3333 5H16.3333C16.8855 5 17.3333 4.55228 17.3333 4V3C17.3333 2.44772 16.8855 2 16.3333 2Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 7H12.3333C11.781 7 11.3333 7.44772 11.3333 8V9C11.3333 9.55228 11.781 10 12.3333 10H16.3333C16.8855 10 17.3333 9.55228 17.3333 9V8C17.3333 7.44772 16.8855 7 16.3333 7Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 12H12.3333C11.781 12 11.3333 12.4477 11.3333 13V14C11.3333 14.5523 11.781 15 12.3333 15H16.3333C16.8855 15 17.3333 14.5523 17.3333 14V13C17.3333 12.4477 16.8855 12 16.3333 12Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartBuilderIcon);
export default __webpack_public_path__ + "static/media/smart-builder-icon.98b29f89731051d3420dbfbda952fd8a.svg";
export { ForwardRef as ReactComponent };